import React, { useCallback, useState } from 'react';
import cx from 'classnames';
import { Select, Tabs, Text } from 'platform-components';
import { POPUP_AXIS, SELECT_THEMES } from 'platform-components';

import { useMedia } from 'react-use';

interface ITab {
    value: string | number;
    content?: React.ReactNode;
}

interface AdaptiveTabsProps {
    mix?: string;
    tabs: ITab[];
    mediaMobile?: string;
    onSelect?: (value: string) => void;
}

export const AdaptiveTabs = ({ mix, mediaMobile = '(max-width: 767px)', onSelect, tabs }: AdaptiveTabsProps) => {
    const isMobile = useMedia(mediaMobile);
    const [selectedTab, setSelectedTab] = useState(tabs[0].value);

    const handleSelectChange = useCallback(
        ({ target: { value } }: { target: { value: string } }) => {
            setSelectedTab(value);
            onSelect?.(value);
        },
        [onSelect]
    );

    const handleTabChange = useCallback(
        (value: string) => {
            setSelectedTab(value);
            onSelect?.(value);
        },
        [onSelect]
    );

    return isMobile ? (
        <Select
            mix={cx(mix)}
            onSelect={handleSelectChange}
            popupAxis={POPUP_AXIS.END}
            theme={SELECT_THEMES.ROUNDED}
            value={selectedTab}
        >
            {tabs.map(({ value, content }) => (
                <Select.Option key={value} value={value}>
                    <Text>{content ?? value}</Text>
                </Select.Option>
            ))}
        </Select>
    ) : (
        <Tabs mix={cx(mix)} theme={Tabs.THEME.ROUNDED}>
            {tabs.map(({ value, content }) => {
                const isSelected = value === selectedTab;

                return (
                    <Tabs.Tab id={value} key={value} onTabSelect={handleTabChange} selected={isSelected}>
                        <Text weight={isSelected ? Text.WEIGHT.M : Text.WEIGHT.S}>{content ?? value}</Text>
                    </Tabs.Tab>
                );
            })}
        </Tabs>
    );
};
